import { render, staticRenderFns } from "./AdvertisingCampaigns.vue?vue&type=template&id=16d47ac5&"
import script from "./AdvertisingCampaigns.vue?vue&type=script&lang=js&"
export * from "./AdvertisingCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports